import * as React from "react";
import { defineMessages, injectIntl } from "react-intl";
const messages = defineMessages({
    phone: {
        id: "phone",
        defaultMessage: "1-877-326-8786"
    },
    url: {
        id: "phone.url",
        defaultMessage: "tel:+18773268786"
    }
});
const PhoneLink = ({ intl }) => {
    const phone = intl.formatMessage(messages.phone);
    const url = intl.formatMessage(messages.url);
    return (<a href={url} itemProp="telephone" className="linkTel">
			{phone}
		</a>);
};
export default injectIntl(PhoneLink);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/PhoneLink.tsx